import { useEffect, useState } from "react";

export default function HighestRankedCard({ ajss }) {
  const [highestAJSS, setHighestAJSS] = useState([]);
  const [latestLabel, setLatestLabel] = useState("");

  useEffect(() => {
    if (!ajss.length) return;

    const monthsOrder = ["Feb", "Apr", "Jun", "Aug", "Oct", "Dec"];
    const getIdx = (m) => monthsOrder.indexOf(m);

    const ranked = ajss
      .map(r => ({
        ...r,
        monthIdx: getIdx(r.month),
        yearNum: Number(r.year)
      }))
      .filter(r => r.monthIdx >= 0);

    if (!ranked.length) return;

    const latestYear = Math.max(...ranked.map(r => r.yearNum));
    const yearData = ranked.filter(r => r.yearNum === latestYear);

    const latestMonthIdx = Math.max(...yearData.map(r => r.monthIdx));
    const latestMonth = monthsOrder[latestMonthIdx];

    const latestData = yearData.filter(r => r.month === latestMonth);

    const numeric = latestData.filter(r => typeof r.rank === "number");
    if (!numeric.length) return;

    const bestRank = Math.min(...numeric.map(r => r.rank));
    const bestPlayers = latestData.filter(r => r.rank === bestRank);

    setHighestAJSS(bestPlayers);
    setLatestLabel(`${latestMonth} ${latestYear}`);
  }, [ajss]);

  return (
    <div className="p-4 bg-white shadow rounded-xl col-span-2">
      <h1 className="mb-4">Highest Ranked Players</h1>

      <div className="space-y-6">
        <div className="grid grid-cols-[auto_1fr] gap-4 items-start">
          <span className="inline-flex items-center space-x-2">
            <span>🌏</span>
            <span className="font-bold">AJSS</span>
            <span>({latestLabel})</span>
          </span>

          <div className="space-y-3 text-right">
            {highestAJSS.length > 0 ? (
              highestAJSS.map(p => (
                <div key={p.id} className="flex flex-col items-end">
                  <p className="font-medium">{p.playerName}</p>
                  <p className="text-sm text-gray-500 mb-1">
                    ({p.ageGroup})
                  </p>
                  <p className="text-lg font-bold text-green-600">#{p.rank}</p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No data</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
